import { render, staticRenderFns } from "./PrivacyProtocolIUV.vue?vue&type=template&id=eff2308c&scoped=true"
import script from "./PrivacyProtocolIUV.vue?vue&type=script&lang=js"
export * from "./PrivacyProtocolIUV.vue?vue&type=script&lang=js"
import style0 from "./PrivacyProtocolIUV.vue?vue&type=style&index=0&id=eff2308c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff2308c",
  null
  
)

export default component.exports